import React, { memo, useEffect, useMemo } from "react";
import Spinner from "@atlaskit/spinner";
import { useQuery } from "@tanstack/react-query";
import { SpinnerContainer } from "../styled/components";
import { NoImage } from "../Icons/NoImage";
import { NoImageWrapper } from "../../RequestDetail/Components/styled";

function MediaClientImage({
  mediaClientConfig,
  hasImage,
  component,
  loadingComponent,
  noImageComponent,
  height = 100,
  width = 100,
}) {
  const { mediaBaseUrl, issuer, mediaJwtToken, fileId } =
    mediaClientConfig || {};
  const fileStoreId = useMemo(
    () => `${fileId}w${width}h${height}`,
    [fileId, width, height]
  );
  const headers = useMemo(
    () => ({
      "X-Issuer": issuer,
      Authorization: `Bearer ${mediaJwtToken}`,
    }),
    [issuer, mediaJwtToken]
  );

  const sizeStyles = useMemo(
    () => ({
      width: `${width}px`,
      height: `${height}px`,
    }),
    []
  );

  const imageQuery = useQuery({
    enabled: !!hasImage && !!mediaClientConfig,
    queryKey: ["getAssetImage", { fileStoreId }],
    queryFn: () =>
      fetch(
        `${mediaBaseUrl}/file/${fileId}/image?${new URLSearchParams({
          width,
          height,
        })}`,
        {
          headers,
        }
      )
        .then((res) => res.blob())
        .then((blob) => URL.createObjectURL(blob)),
    placeholder: (prev) => prev,
    refetchOnMount: false,
  });

  if (imageQuery.isFetching)
    return (
      loadingComponent || (
        <SpinnerContainer
          style={
            height
              ? { height: `${height}px`, width: `${width || height}px` }
              : {}
          }
        >
          <Spinner size="medium" />
        </SpinnerContainer>
      )
    );

  if (!hasImage || imageQuery.isError)
    return (
      noImageComponent || (
        <NoImageWrapper style={sizeStyles}>
          <NoImage size={height} />
        </NoImageWrapper>
      )
    );

  if (!component)
    return (
      <img src={imageQuery.data} height={height} width={width} alt="asset" />
    );

  return component(imageQuery.data, width, height);
}

export default memo(MediaClientImage);
